export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

/** Same legal name as loan forms, ledgers, and backend PDFs (override via .env if needed). */
export const FINANCE_NAME =
  process.env.REACT_APP_FINANCE_NAME || 'SHREE SIDDHARAMESHWAR FINANCE AND LEASING';

/** Location line on printed reports (matches address used on loan documents in this app). */
export const FINANCE_ADDRESS =
  process.env.REACT_APP_FINANCE_ADDRESS || 'Kasgi, Maharashtra, India';

